import { SupplierColumns } from "components/suppliers/utils";
import { ColumnSettingFieldEnum } from "lib/generated/app-api";
import { ColumnSetting } from "lib/types/models";

export const DEFAULT_SUPPLIER_COLUMNS: ColumnSetting<SupplierColumns>[] = [
  { title: "Name", field: "name", disabled: true },
  { title: "Lots", field: "frameworkLots" },
  { title: "Last activity", field: "frameworkLastActivity" },
  { title: "Call-offs", field: "frameworkCallOffs" },
  { title: "Is SME", field: "sme" },
];

export const ALL_SUPPLIER_COLUMNS: ColumnSetting<SupplierColumns>[] = [
  ...DEFAULT_SUPPLIER_COLUMNS,
  { title: "Country", field: "country" },
];

export const DEFAULT_CALL_OFF_NOTICE_COLUMNS: ColumnSettingFieldEnum[] = [
  "relevance_score",
  "title",
  "suppliers",
  "value",
  "published_date",
];
